<div class="pades-signature-zone-modal">
  <div class="modal-header">
    <div class="header-content">
      <h3 class="modal-title">Firma visible en el PDF</h3>
      <p class="modal-subtitle">Dibuja un recuadro donde quieras la firma. Si es pequeño, lo ampliamos automáticamente al tamaño mínimo recomendado.</p>
      <div class="page-info" *ngIf="totalPages > 0">Página {{ page }} de {{ totalPages }}</div>
    </div>
    <button class="btn-close" (click)="cancel()" type="button" aria-label="Cerrar">
      <i class="fas fa-times" aria-hidden="true"></i>
    </button>
  </div>

  <div class="modal-controls">
    <div class="controls-group">
      <button class="btn-control" (click)="goToPage(page - 1)" [disabled]="page <= 1" type="button" aria-label="Ir a la página anterior">
        <i class="fas fa-chevron-left" aria-hidden="true"></i> Anterior
      </button>
      <button class="btn-control" (click)="goToPage(page + 1)" [disabled]="page >= totalPages" type="button" aria-label="Ir a la página siguiente">
        Siguiente <i class="fas fa-chevron-right" aria-hidden="true"></i>
      </button>
    </div>
    <div class="controls-group" *ngIf="!drawMode">
      <button class="btn-control btn-draw" type="button" (click)="startDrawMode()" aria-label="Activar modo para dibujar área de firma">
        <i class="fas fa-vector-square" aria-hidden="true"></i> Dibujar área de firma
      </button>
    </div>
    <div class="controls-group" *ngIf="drawMode">
      <button class="btn-control btn-cancel-draw" type="button" (click)="cancelDrawMode()" aria-label="Desactivar dibujo y usar solo desplazamiento">
        <i class="fas fa-undo" aria-hidden="true"></i> Solo desplazar
      </button>
    </div>
  </div>

  <div class="pdf-zone-wrapper">
    <div class="pdf-zone-container" #scrollContainer>
      <div class="pdf-content-wrapper"
           [style.width.px]="contentWidth || null"
           [style.height.px]="contentHeight || null">
        <div class="pdf-viewer-inner">
          <pdf-viewer #pdfViewer
            [src]="pdfSrc"
            [page]="page"
            [zoom]="1"
            [original-size]="false"
            [show-all]="false"
            [render-text]="true"
            (after-load-complete)="onLoadComplete($event)"
            (page-rendered)="onPageRendered()"
            class="zone-pdf-viewer">
          </pdf-viewer>
        </div>
        <div class="draw-overlay" #overlay
             [class.draw-active]="drawMode"
             (pointerdown)="onOverlayPointerDown($event)"
             (pointermove)="onOverlayPointerMove($event)"
             (pointerup)="onOverlayPointerUp($event)"
             (pointercancel)="onOverlayPointerCancel($event)"
             (pointerleave)="onOverlayPointerLeave($event)"></div>
        <div class="zone-rect" *ngIf="rect && (rect.width > 0 || rect.height > 0)"
             [class.zone-rect-valid]="isZoneLargeEnough()"
             [class.zone-rect-warning]="hasValidRect() && !isZoneLargeEnough()"
             [style.left.px]="rect.left"
             [style.top.px]="rect.top"
             [style.width.px]="rect.width"
             [style.height.px]="rect.height"></div>
      </div>
    </div>
  </div>

  <div class="modal-footer-block">
    <p class="zone-size-hint zone-size-hint--info" *ngIf="getZoneSizeWarning()" role="status">
      <i class="fas fa-info-circle" aria-hidden="true"></i>
      {{ getZoneSizeWarning() }}
    </p>
    <div class="modal-actions">
      <button class="btn-secondary" type="button" (click)="cancel()">Cancelar</button>
      <button class="btn-primary" type="button" (click)="confirm()" [disabled]="!canConfirm()">
        Confirmar zona
      </button>
    </div>
  </div>

  <div class="appearance-modal-backdrop" *ngIf="showAppearanceModal && hasValidRect()">
    <div class="appearance-modal-card" role="dialog" aria-modal="true" aria-label="Configurar apariencia de firma">
      <div class="mini-config-head">
        <span class="mini-title">Así quedará la firma</span>
        <span class="mini-subtitle" *ngIf="!signerCnEditable">
          La firma visible incluye el nombre del certificado ({{ signerCn }}). También puedes cargar tu propia imagen.
        </span>
        <span class="mini-subtitle" *ngIf="signerCnEditable">
          Escribe el nombre exactamente como aparece en tu certificado. El sello será el mismo de Certifirma Digital Virtual / P10.
        </span>
      </div>

      <label class="signer-cn-field" *ngIf="signerCnEditable">
        <span class="signer-cn-label">Nombre del firmante</span>
        <input
          type="text"
          class="signer-cn-input"
          [value]="signerCn"
          (input)="onSignerCnInput($any($event.target).value)"
          placeholder="Ej. Nombres completos del firmante"
          autocomplete="name"
          maxlength="120"
        />
        <span class="error-inline" *ngIf="!hasValidSignerCn() && signerCn.trim()">Indica el nombre completo del certificado.</span>
      </label>

      <div class="mini-option-list">
        <button type="button" class="mini-option-btn" [class.selected]="visualMode === 'default'" (click)="useDefaultStamp()">
          <i class="fas fa-stamp" aria-hidden="true"></i> Firma visible
        </button>
        <button type="button" class="mini-option-btn" [class.selected]="visualMode === 'upload'" (click)="triggerFileInput()">
          <i class="fas fa-image" aria-hidden="true"></i> Cargar imagen
        </button>
      </div>

      <input #fileInput type="file" accept=".png,.jpg,.jpeg" (change)="onFileSelected($event)" hidden />
      <span class="file-name-inline" *ngIf="visualMode === 'upload' && selectedFile">{{ selectedFile.name }}</span>
      <span class="file-name-inline" *ngIf="visualMode === 'upload' && imageChoice?.imageBase64 && !selectedFile">Imagen cargada</span>
      <span class="error-inline" *ngIf="uploadError">{{ uploadError }}</span>

      <div class="signature-preview">
        <span class="signature-preview-label">Vista previa:</span>
        <div class="signature-preview-box preview-adobe-stamp">
          <ng-container [ngSwitch]="visualMode">
            <div *ngSwitchCase="'upload'" class="preview-upload-layout">
              <div class="preview-image-tag">
                <i class="fas fa-image" aria-hidden="true"></i>
                <span>Imagen cargada</span>
              </div>
              <div class="preview-date-block">Fecha: {{ getPreviewDateLabel() }}</div>
            </div>
            <div *ngSwitchDefault class="preview-adobe-layout preview-adobe-three-col">
              <div class="preview-col preview-col-cn">{{ signerCn.trim() || 'Nombre del firmante' }}</div>
              <div class="preview-col preview-col-brand" aria-hidden="true"></div>
              <div class="preview-col preview-col-meta">{{ getPreviewDescriptionText() }}</div>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="appearance-actions">
        <button
          class="btn-secondary"
          type="button"
          (click)="closeAppearanceModal()"
          [disabled]="signerCnEditable && !hasValidSignerCn()"
        >Listo</button>
      </div>
    </div>
  </div>
</div>
